import { useEffect } from 'react';

declare global {
    interface Window {
        dataLayer?: unknown[];
    }
}

/**
 * Loads Google Tag Manager for the given container id and optionally pushes a
 * conversion event once loaded. No-ops when `gtmKey` is empty/null.
 */
export const useGoogleTagManager = (gtmKey: string | null, event?: string | null): void => {
    useEffect(() => {
        if (!gtmKey) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmKey}`;
        document.body.appendChild(script);

        if (event) {
            window.dataLayer.push({ event });
        }

        return () => {
            document.body.removeChild(script);
        };
    }, [gtmKey, event]);
};
